import axios from 'axios';
import { downloadBlobResponse } from './billingReconciliationApi.js';

const BASE_URL = '/api/billing-reconciliation';

const cleanParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
);

const requestConfig = (params = {}, signal) => {
  const config = { params: cleanParams(params) };
  if (signal) config.signal = signal;
  return config;
};

const encoded = (value) => encodeURIComponent(String(value));

export const getBillingReconciliationHistory = async (params = {}) => {
  const { signal, ...rest } = params;
  const { data } = await axios.get(`${BASE_URL}/history`, requestConfig(rest, signal));
  return data;
};

export const getBillingReconciliationHistoryBacLookup = async ({ runId, bac, ...params } = {}) => {
  if (!runId) throw new Error('runId is required');
  if (!bac) throw new Error('bac is required');
  const { signal, ...rest } = params;
  const { data } = await axios.get(`${BASE_URL}/runs/${encoded(runId)}/history/bac/${encoded(bac)}`, requestConfig(rest, signal));
  return data;
};

export const updateBillingReconciliationHistoryAdjustment = async ({
  program = 'website',
  serviceMonth,
  finalAdjustedAmount = null,
  note = null,
} = {}) => {
  if (!program) throw new Error('program is required');
  if (!serviceMonth) throw new Error('serviceMonth is required');
  const { data } = await axios.patch(`${BASE_URL}/history/${encoded(program)}/${encoded(serviceMonth)}`, cleanParams({
    finalAdjustedAmount,
    note,
  }));
  return data;
};

export const downloadBillingReconciliationSourceFile = async ({ storageKey, fileName = 'billing-reconciliation-source-file' } = {}) => {
  if (!storageKey) throw new Error('storageKey is required');
  const encodedStorageKey = String(storageKey).split('/').map((segment) => encoded(segment)).join('/');
  const response = await axios.get(`${BASE_URL}/files/${encodedStorageKey}`, { responseType: 'blob' });
  downloadBlobResponse(response, fileName);
};
